import moment from "moment";
import { useDateFormatter } from "PFCore/hooks/use_date_formatter";

import css from "./header.module.scss";

interface HeaderTimeAgoProps {
  time: string;
}

export const HeaderTimeAgo = ({ time }: HeaderTimeAgoProps) => {
  const { formatDate } = useDateFormatter();

  const createdAt = moment(time);
  const useTimeAgo = createdAt.diff(Date.now(), "days") > -28;
  const copy = useTimeAgo ? createdAt.fromNow(false) : formatDate(createdAt);

  return <div className={css.time}>{copy}</div>;
};
